import type { LucideIcon } from 'lucide-react';
import { Handshake, LayoutDashboard, Mail, User } from 'lucide-react';

export interface SubMenuItem {
  label: string;
  path: string;
}

export interface SidebarCategory {
  label: string;
  icon: LucideIcon;
  basePath: string; // first submenu item path to navigate on click
  items: SubMenuItem[];
}

const config: SidebarCategory[] = [
  {
    label: 'Dashboard',
    icon: LayoutDashboard,
    basePath: '/home',
    items: [
      { label: 'Home', path: '/home' },
    ],
  },
  {
    label: 'Sales',
    icon: Handshake,
    basePath: '/tasks',
    items: [
      { label: 'Tasks', path: '/tasks' },
      { label: 'Sales Analytics Suite', path: '/sales/analytics' },
      { label: 'Leads', path: '/leads' },
      { label: 'Accounts', path: '/accounts' },
      { label: 'Interactions', path: '/interactions' },
    ],
  },
  {
    label: 'Inbox',
    icon: Mail,
    basePath: '/messages',
    items: [
      { label: 'Inbox', path: '/messages' },
    ],
  },
  {
    label: 'Contacts',
    icon: User,
    basePath: '/contacts',
    items: [
      { label: 'Contacts', path: '/contacts' },
      { label: 'Org Chart', path: '/contacts/org-chart' },
      { label: 'Companies', path: '/contacts/companies' },
      // { label: 'Forms', path: '/contacts/forms' }, // Temporarily hidden
    ],
  },
];

export default config;
